import type { FC } from 'react'
import type { ERC20Symbols } from '@g4g/wallet-modal/types'
import { classNames } from '@g4g/utils/src/react/class-names'
import TokenLogo from '../../shared/wallet/TokenLogo'

type CryptoPriceTagSize = 'small' | 'large'

const CryptoPriceTag: FC<{
  symbol: ERC20Symbols
  price?: string
  priceValueClassNames?: string
  'data-cy-spec'?: string
  size: CryptoPriceTagSize
  layout: 'compact' | 'row' | 'row-grow'
}> = ({ symbol, price, size, layout, 'data-cy-spec': dataCySpec, priceValueClassNames }) => (
  <div className={classNames('flex', layout === 'row' && 'space-x-2')}>
    <div className={classNames('flex items-center space-x-1', layout === 'row-grow' && 'grow')}>
      <div className={classNames(layout === 'compact' && 'self-start')}>
        <TokenLogo
          sizeClassName={classNames(
            size === 'small' && 'w-[18px] h-[18px]',
            size === 'large' && 'w-8 h-8 sm:w-12 sm:h-12'
          )}
          symbol={symbol}
        />
      </div>
      <div
        data-cy="shop-cart-crypto-price-tag"
        data-cy-spec={dataCySpec}
        className={classNames(layout === 'compact' ? 'flex-col' : 'flex-row')}
      >
        {layout === 'compact' && <div className="font-bold leading-none sm:text-lg">{price}</div>}
        <span className={classNames('font-bold', layout === 'compact' && 'text-sm')}>{symbol}</span>
      </div>
    </div>
    <div
      className="flex items-center"
      data-cy="shop-cart-crypto-price-tag"
      data-cy-spec={dataCySpec}
    >
      {(layout === 'row' || layout === 'row-grow') && (
        <div className={classNames(priceValueClassNames, 'text-lg font-bold')}>{price}</div>
      )}
    </div>
  </div>
)

export default CryptoPriceTag
